
export default {
  name: 'ConfigurableFlexItem',
  values: {
    flexGrow: undefined,
    flexShrink: undefined,
    flexBasis: undefined,
    alignSelf: undefined,
    justifySelf: undefined,
  },
  meta: {
    extendable: false,
  },
}
